import moment from 'moment';

export const createReporting = obj => ({
    investmentFund: `api/investment_funds/${obj.fundId}`,
    document: `api/documents/${obj.docId}`,
    emailSubject: obj.subject.trim(),
    recipientType: obj.recipient,
    date: moment(obj.date).utcOffset(0).startOf('day'),
});

export const updateReporting = obj => ({
    investmentFund: `api/investment_funds/${obj.fundId}`,
    document: obj.docId ? `api/documents/${obj.docId}` : obj.docId,
    emailSubject: obj.subject.trim(),
    recipientType: obj.recipient,
    date: moment(obj.date).utcOffset(0).startOf('day'),
    id: obj.id,
});
